import React, { useContext, useEffect, useState } from 'react'
import styles from './Birthday.module.css'
import { FormTitle } from '../../../Common/FormTitle'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { FormField } from '../../../Common/FormField'
import { handleKeyDown, handleNumericInput, validateDate } from './validate'
import { AgeCaluculation } from './AgeCaluculation'
import { DATE_CONSTANTS } from '../../../../constants/progressBanner'
import { HandleYearChangeFunction, SetMonthFunction } from './types'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'
import { StepContext } from '../../StepContainer'

export const Birthday = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const { formState } = useContext(StepContext)

    const getInitialYearAndMonth = () => {
        if (formState.birthday) {
            const [year, month] = formState.birthday.split('-')
            return { year: year || '', month: month || '' }
        }
        return { year: '', month: '' }
    }

    const initialValues = getInitialYearAndMonth()
    const [year, setYear] = useState<string>(initialValues.year)
    const [month, setMonth] = useState<string>(initialValues.month)
    const [hasInteracted, setHasInteracted] = useState<boolean>(false)
    const currentDate = new Date()
        .toISOString()
        .slice(0, DATE_CONSTANTS.DATE_SLICE_END)
    const [isFormValid, setIsFormValid] = useState<boolean>(false)
    const [validateMessage, setValidateMessage] = useState<string>('')
    const [age, setAge] = useState<number | null>(null)

    const birthday =
        year !== '' && month !== ''
            ? `${year}-${String(month).padStart(DATE_CONSTANTS.MONTH_START_PAD, '0')}-01`
            : null

    useEffect(() => {
        if (hasInteracted) {
            setIsFormValid(
                validateDate(year, month, currentDate, setValidateMessage)
            )
        } else if (year !== '' || month !== '') {
            setHasInteracted(true)
        }

        if (year && month && currentDate) {
            const calculatedAge = AgeCaluculation({
                year,
                month,
                currentDate,
            })
            setAge(calculatedAge)
        }
    }, [month, year, hasInteracted, currentDate])

    const handleMonthChange: SetMonthFunction = value => {
        const numericValue = value.replace(/[^0-9]/g, '')

        const normalizedValue =
            numericValue.length > 2
                ? numericValue.replace(/^0+/, '')
                : numericValue

        if (normalizedValue === '' || parseInt(normalizedValue, 10) <= 12) {
            setMonth(normalizedValue)
            if (!hasInteracted) setHasInteracted(true)
        }
    }

    const handleYearChange: HandleYearChangeFunction = value => {
        handleNumericInput(value, setYear)
        if (!hasInteracted) setHasInteracted(true)
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText='誕生月はいつですか？'
                        dataViewLabel={dataViewLabel('EF_StepForm_誕生月')}
                        dataClickLabel={dataClickLabel('EF_StepForm_誕生月-戻る')}
                    />
                </div>
                <div className={styles.field}>
                    <FormField
                        label='年'
                        placeholder='2000'
                        value={year}
                        isInputType='tel'
                        onChange={handleYearChange}
                        onKeyDown={handleKeyDown}
                    />
                    <FormField
                        label='月'
                        placeholder='01'
                        value={month}
                        isInputType='tel'
                        onChange={handleMonthChange}
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {hasInteracted && validateMessage && (
                    <div className={styles.errorMessagesWrapper}>
                        <p className={styles.errorMessages}>
                            {validateMessage}
                        </p>
                    </div>
                )}

                <NextButton
                    formKey={'birthday'}
                    formValue={birthday}
                    displayFormKey={'birthday'}
                    displayFormValue={`${year}年${month}月(${age}歳)`}
                    isDisabled={!isFormValid}
                    dataClickLabel={dataClickLabel('EF_StepForm_誕生月-次へ')}
                />
            </div>
        </div>
    )
}
